import type { ReactNode, SVGProps } from "react";

export function ArrowNextIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="8"
			viewBox="0 0 5 8"
			width="5"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M3.49273 3.99851L0.183554 0.973576C-0.0611846 0.749684 -0.0611846 0.387644 0.183554 0.166133C0.428292 -0.0553777 0.824039 -0.0553777 1.06878 0.166133L4.81796 3.5936C5.05489 3.81035 5.0601 4.15809 4.83619 4.38199L1.07138 7.83327C0.949012 7.94522 0.787589 8 0.628769 8C0.46995 8 0.308527 7.94522 0.186158 7.83327C-0.0585808 7.60938 -0.0585808 7.24734 0.186158 7.02583L3.49273 3.99851Z"
				fill="currentColor"
			/>
		</svg>
	);
}
